export enum UserSignupState {
    PENDING = "Pending",
    APPROVED = "Approved",
    REJECTED = "Rejected",
}
